import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';
import { UserCompanyService } from '../usercompany/usercompany.service';
import { UserCompanyModel } from '../usercompany/usercompany.model';
import { InvoiceService } from '../../invoice/invoice/invoice.service';
import * as FileSaver from 'file-saver';
import { UserContactService } from './usercontact.service';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { TicketService } from '../../invoice/tickets/ticket.service';
import { ActivityModel } from '../activity/activity.model';
import { ActivityService } from '../activity/activity.service';
import { CoreComponent } from '../../../core/header/core.component';

export enum InvoiceLayout {
  ClassicInvoiceLayout = 1,
  CorporateInvoiceLayout = 2,
  ElegantInvoiceLayout = 3,
  ModernInvoiceLayout = 4,
}

@Component({
    selector: 'convfact-userlogo',
    templateUrl: './userlogo.component.html',
    styleUrls: ['./usercontact.component.css'],
    standalone: false
})
export class UserLogoComponent implements OnInit {
  errors: Record<string, unknown> = {};
  userCompany!: UserCompanyModel;
  activity!: ActivityModel;
  activityId!: number;
  activityUid!: string;
  link!: string;
  done = false;
  ready = false;
  fileTicket: any;
  fileLeft: any;
  fileCenter: any;
  fileFooter: any;
  test = false;
  pdfTicketDownloaded = false;
  previewLoadingLayoutId: number | null = null;

  nameTicket = '';
  nameLeft = '';
  nameCenter = '';
  nameFooter = '';

  doneTicket = false;
  doneLeft = false;
  doneCenter = false;
  doneFooter = false;

  public suggestedTextLODP = false;

  public readonly snackBar = inject(MatSnackBar);
  public readonly invoiceService = inject(InvoiceService);
  private readonly userCompanyService = inject(UserCompanyService);
  private readonly userContactService = inject(UserContactService);
  private readonly ticketService = inject(TicketService);
  private readonly activityService = inject(ActivityService);
  private readonly coreComponent = inject(CoreComponent);
  private readonly destroyRef = inject(DestroyRef);

  // Colores predefinidos para personalizar el color de acento de la factura
  accentColorPresets = [
    '#1F3A5F', '#16324F', '#7A5C3E', '#2B2B2B',
    '#C0392B', '#D97706', '#166534', '#0F766E',
    '#1D4ED8', '#4338CA', '#7E22CE', '#BE185D',
    '#4B5563', '#78716C', '#0369A1', '#065F46',
  ];

  invoiceLayouts = [
    {
      id: InvoiceLayout.ClassicInvoiceLayout,
      name: 'Clásico',
      subtitle: 'Diseño sencillo y profesional',
      tag: 'Por defecto',
      description: 'Buena legibilidad y estructura clara, ideal para la mayoría de negocios.',
      preview: '/assets/img/invoice-classic.png',
    },
    {
      id: InvoiceLayout.CorporateInvoiceLayout,
      name: 'Corporativo',
      subtitle: 'Estilo corporativo y formal',
      tag: '',
      description: 'Una factura más sobria y orientada a imagen de empresa.',
      preview: '/assets/img/invoice-corporate.png',
    },
    {
      id: InvoiceLayout.ElegantInvoiceLayout,
      name: 'Elegante',
      subtitle: 'Diseño moderno y refinado',
      tag: '',
      description: 'Pensado para negocios que quieren una presentación más cuidada.',
      preview: '/assets/img/invoice-elegant.png',
    },
    {
      id: InvoiceLayout.ModernInvoiceLayout,
      name: 'Moderno',
      subtitle: 'Minimalista y actual',
      tag: 'Nuevo',
      description: 'Un estilo limpio, visual y más contemporáneo.',
      preview: '/assets/img/invoice-modern.png',
    },
  ];

  submit(): void {}

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  async downloadInvoice(): Promise<void> {
    this.test = true;

    const selectedLayout =
      this.activity && this.activity.invoiceLayout
        ? this.activity.invoiceLayout
        : InvoiceLayout.ClassicInvoiceLayout;

    try {
      const response = await this.invoiceService.pdfdummy(
        selectedLayout,
        this.activity?.invoiceAccentColor,
        this.activity?.invoiceSidebarText
      );
      FileSaver.saveAs(response, Utils.GetFileName('prueba', consts.EXT_PDF));
    } finally {
      this.test = false;
    }
  }

  selectAccentColor(color: string): void {
    this.activity.invoiceAccentColor = color;
  }

  async downloadTicket(): Promise<void> {
    this.pdfTicketDownloaded = true;

    try {
      const response = await this.ticketService.pdfdummy();
      FileSaver.saveAs(response, Utils.GetFileName('prueba', consts.EXT_PDF));
    } finally {
      this.pdfTicketDownloaded = false;
    }
  }

  async previewLayout(
    layout: { id: number; name: string },
    event: Event
  ): Promise<void> {
    event.stopPropagation();
    this.previewLoadingLayoutId = layout.id;

    try {
      const response = await this.invoiceService.pdfdummy(
        layout.id,
        this.activity?.invoiceAccentColor,
        this.activity?.invoiceSidebarText
      );
      FileSaver.saveAs(response, Utils.GetFileName('preview-' + layout.name, consts.EXT_PDF));
    } finally {
      this.previewLoadingLayoutId = null;
    }
  }

  async deleteLogo(position: string): Promise<void> {
    const response = await this.userContactService.deleteLogo(position);
    this.displayInfo(response);

    if (position === 'center') {
      this.doneCenter = false;
    }
    if (position === 'left') {
      this.doneLeft = false;
    }
    if (position === 'footer') {
      this.doneFooter = false;
    }
    if (position === 'ticket') {
      this.doneTicket = false;
    }
  }

  getFileName(event: any): string {
    return event.target.files[0].name;
  }

  saveEventTicket(event: any): void {
    this.fileTicket = event;
    this.nameTicket = this.getFileName(event);
    this.fileChange('ticket');
  }

  saveEventLeft(event: any): void {
    this.fileLeft = event;
    this.nameLeft = this.getFileName(event);
    this.fileChange('left');
  }

  saveEventCenter(event: any): void {
    this.fileCenter = event;
    this.nameCenter = this.getFileName(event);
    this.fileChange('center');
  }

  saveEventFooter(event: any): void {
    this.fileFooter = event;
    this.nameFooter = this.getFileName(event);
    this.fileChange('footer');
  }

  async fileChange(position: string): Promise<void> {
    this.done = true;

    try {
      if (position === 'center') {
        const response = await this.userContactService.userLogo(this.fileCenter, position);
        this.displayInfo(response);
        this.doneCenter = true;
        return;
      }

      if (position === 'left') {
        const response = await this.userContactService.userLogo(this.fileLeft, position);
        this.displayInfo(response);
        this.doneLeft = true;
        return;
      }

      if (position === 'footer') {
        const response = await this.userContactService.userLogo(this.fileFooter, position);
        this.displayInfo(response);
        this.doneFooter = true;
        return;
      }

      if (position === 'ticket') {
        const response = await this.userContactService.userLogo(this.fileTicket, position);
        this.displayInfo(response);
        this.doneTicket = true;
        return;
      }
    } finally {
      this.done = false;
    }
  }

  async save(): Promise<void> {
    try {
      const [savedActivity, savedCompany] = await Promise.all([
        this.activityService.editData(this.activity.uid, this.activity),
        this.userCompanyService.editData(this.userCompany),
      ]);
      this.activity = savedActivity;
      if (savedCompany) this.userCompany = savedCompany;
      this.displayInfo('Cambios guardados correctamente');
    } catch (errors: any) {
      const message = errors && errors.error && errors.error.message ? errors.error.message : 'No se pudieron guardar los cambios';
      this.displayInfo(message);
    }
  }

  async setActualLogo(): Promise<void> {
    const response = await this.userContactService.userLogos();

    if (response.left !== '') {
      this.nameLeft = 'Logo izquierdo.png';
      this.doneLeft = true;
    }
    if (response.center !== '') {
      this.nameCenter = 'Logo central.png';
      this.doneCenter = true;
    }
    if (response.footer !== '') {
      this.nameFooter = 'Logo pie de página.png';
      this.doneFooter = true;
    }
    if (response.ticket !== '') {
      this.nameTicket = 'Logo ticket.png';
      this.doneTicket = true;
    }
  }

  async ngOnInit(): Promise<void> {
    this.userCompany = await this.userCompanyService.loadData();
    this.link = 'https://api.handly.es/uploads/' + this.userCompany.uid + '.png';
    await this.setActualLogo();
    this.activityUid = this.coreComponent.activitySelected;

    try {
      this.activity = await this.activityService.loadData(this.activityUid);
    } finally {
      this.ready = true;
    }
  }

  public onChangesuggestedText(event: MatCheckboxChange): void {
    if (event.checked) {
      this.userCompany.lopd =
        'En cumplimiento con la normativa europea de protección de datos RGPD, declaramos que sus datos personales serán tratados con la finalidad de gestionar la relación contractual entre las partes, así como a fines de gestión económica, contable, financiera y de control';
    } else {
      this.userCompany.lopd = '';
    }
  }
  public trackByIndex(i: number) { return i; }

}